import React from "react";

interface TimeInputProps {
  hours: number;
  minutes: number;
  seconds: number;
  onChange: (h: number, m: number, s: number) => void;
}

const format = (n: number) => n.toString().padStart(2, "0");

export const TimeInput: React.FC<TimeInputProps> = ({
  hours,
  minutes,
  seconds,
  onChange,
}) => {
  const handleChange = (index: number, value: string) => {
    const num = Number(value.replace(/\D/g, ""));

    let h = hours;
    let m = minutes;
    let s = seconds;

    if (index === 0) h = Math.min(23, num);
    if (index === 1) m = Math.min(59, num);
    if (index === 2) s = Math.min(59, num);

    onChange(h, m, s);
  };

  return (
    <div style={{ display: "flex", gap: 4 }}>
      <input
        value={format(hours)}
        onChange={(e) => handleChange(0, e.target.value)}
        maxLength={2}
      />

      <span>:</span>

      <input
        value={format(minutes)}
        onChange={(e) => handleChange(1, e.target.value)}
        maxLength={2}
      />

      <span>:</span>

      <input
        value={format(seconds)}
        onChange={(e) => handleChange(2, e.target.value)}
        maxLength={2}
      />
    </div>
  );
};
